export default {
  curbSideOrder: 'Curbside',
  onlineOrder: 'Online',
  walkUpMode: 'Walk up',
  textToPayMode: 'Call in',
  orderType_scanToPay: 'Scan to pay',
  orderType_POS: 'POS',
  orderType_Table: 'Table',
  orderType_Tab: 'Tab',
  orderType_speedOrder: 'Speed Order',
  orderType_driveThru: 'Drive Thru',
  kioskMode: 'Kiosk',
  table: 'Table',
  tab: 'Tab',
  SPEED_ORDER: 'Speed Order',
  DRIVE_THRU: 'Drive Thru',
  EXPANDE_CHECK_DETAILS: 'Expanded-check-details',
  IS_PRINT_POPUP: 'Print-popup',
  NOTIFY_GUEST: 'Notify Guest',
  INDIVIDUAL_ITEM: 'Individual Item Labels',
  ORDER_ITEMS: 'Order + Item Labels',
  FULL_ORDER: 'Full Order Label',
  KITCHEN_TICKET: 'Kitchen Ticket',
  GUEST_RECEIPT: 'Guest Receipt',
  CLOSE: 'Close',
  BACK: 'Back',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  YES: 'Yes',
  NO: 'No',
  CHECK_DETAILS_VIEW: 'Check Details View',
  EXPAND_VIEW: 'Expand view',
  confirmationMessage: 'Confirmation Message',
  sendSmsPopupMsg:
    'This will send an SMS message to the phone number on file. Do you want to continue?',
  smdSendLoaderHeading: 'Sending SMS',
  ACTIONS: 'Actions',
  MARKED_AS_PICKEDUP: 'Mark As Picked Up',
  MOVE_TO_INPROGRESS: 'Move To In-Progress',
  CANCEL_ORDERS: 'Cancel Order',
  PRE_AUTH: 'Pre Auth',
  PRINT: 'Print',
  RECEIPT: 'Receipt',
  SYNC_CHECK: 'Sync Check',
  MARK_AS_DONE: 'Mark As Done',
  MOVE_TO_PICKED_UP: 'Move To Picked Up',
  BACK_TO_PENDING: 'Back To Pending',
  BACK_TO_INPROGRESS: 'Back To In-Progress',
  MARK_AS_NOT_PICKEDUP: 'Mark as Not Picked Up',
  orderCancellation: 'Order Cancellation',
  RECEIPT_BTN: 'receipt',
  NO_ITEMS_FOUND: 'No Items Found',
  SUBTOTAL: 'Subtotal',
  ITEMS: 'Items',
  DISCOUNTS: 'Discounts',
  CHARGES: 'Charges',
  TAX: 'Tax',
  TIP: 'Tip',
  PAID: 'Paid',
  DUE: 'Due',
  TIME: 'Time',
  VEHICLE_INFO: 'Vehicle Info',

  //Receipt Header
  SELECT: 'Select',
  TYPE: 'Type',
  CARD: 'Card',
  NAME_ON_CARD: 'Name',
  TOTAL: 'Total',
  TIP: 'Tip',
  PAYMENT: 'Payment',
  REFUND: 'Refund',
  EMAIL: 'Email',
  SMS: 'Text',
  RECEIPT_STATUS: 'Status',
  //pop up message
  PRINT_DATA: 'Print data',
  EMAIL_RECEIPT: 'Email Receipt',
  SMS_RECEIPT: 'Text Receipt',
  EMAIL_SPINNER_MSG: 'Generating email receipt',
  SMS_SPINNER_MSG: 'Generating sms receipt',
  EMAIL_ERROR: 'Please enter valid email address',
  //counetrs
  CUSTOM_STANDARD_MESSAGES: 'Custom and Standard Messages',
  TOTAL_CHECKS: 'All Checks',
  OPEN: 'Open',
  CLOSED: 'Closed',
  ELAPSED: 'Elapsed',
  PAID: 'Paid',
  PARTIAL_PAID: 'Partial Paid',
  UNPAID: 'Unpaid',
  PENDING: 'Pending',
  INPROGRESS: 'In Progress',
  DONE: 'Done',
  PICKED_UP: 'Picked Up',
  CHECKED_IN: 'Checked In',
  UNASSIGNMENT: 'Unassigned',
  // table headers
  CHANNEL: 'CHANNEL',
  CHECK: 'CHECK',
  TAB: 'TAB',
  TABEL_TAB: 'TABLE/ TAB',
  EMPLOYEE: 'EMPLOYEE',
  NAME: 'NAME',
  PHONE: 'PHONE',
  STATUS: 'STATUS',
  EMPLOYEE: 'EMPLOYEE',
  GUEST: 'GUEST',
  ORDER: 'ORDER',
  REMAINING: 'REMAINING',
  CHECKED_IN_NOTE: 'CHECK IN NOTE',
  STORE: 'STORE',
  // filters
  COMPLETE: 'Complete',
  SEE_COUNTER: 'See Counter',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  CURBSIDE: 'Curbside',
  ONLINE: 'Online',
  WALK_UP: 'Walk up',
  CALL_IN: 'Call in',
  KIOSK: 'Kiosk',
  SCAN_TO_PAY: 'Scan to pay',
  CALL_CENTER: 'Call Center',
  COUNTER: 'Counter',
  ORDER_PAY: 'Order Pay',

  //hamburger settings

  FUTURE_ORDERS: 'Future Orders',
  OUT_OF_STOCK: 'Out Of Stock',
  BULK_TEXT_TO_PAY: 'Bulk Text to pay',
  BTTP_CHECK: 'Check',
  BTTP_TABLE: 'Table',
  BTTP_EMPLOYEE: 'Employee',
  BTTP_TOTAL: 'Total',
  BTTP_PHONE_NUMBER: 'Phone Number',
  BTTP_STATUS: 'Status',
  BTTP_MSG: 'Message',
  MODIFIERS: 'Modifiers',
  OUT_OF_STOCK_ITEMS: 'Out Of Stock Items',
  OUT_OF_STOCK_MODIFIERS: 'Out Of Stock Modifiers',
  SELECTED_ITEMS: 'Selected Items',
  SELECTED_MODIFIERS: 'Selected Modifiers',
  SEARCH: 'Search',
  CLEAR_ALL: 'Clear All',
  CLEAR: 'Clear',
  MARK_IN_STOCK: 'Mark In-Stock',
  MARK_OUT_OF_STOCK: 'Mark Out of stock',
  PROCEED: 'Proceed',
  UPDATE_STOCK_STATUS: 'Update Stock Status',
  NO_MODIFIERS: 'No Modifiers',
  NO_ITEMS: 'No Items',
  NO_MODIFIERS_FOUND: 'No Modifiers Found',
  SENSORS: 'Sensors',
  ABOUT: 'About',
  TABLE: 'Table',
  NAMED: 'Named',
  TABLE_SENSORS: 'Table Sensors',
  NAMED_SENSORS: 'Named Sensors',
  SENSOR_GROUP: 'Sensor Group',
  ADD_SENSOR: 'Add Sensor',
  ADD_QR: 'Add QR',
  REGISTER_SENSOR: 'Register Sensor',
  RE_SCAN: 'Re-Scan',
  EMPLOYEE_ASSIGN: 'Assign Employee',
  EMPLOYEE_VIEW: 'Employee View',
  TABLE_VIEW: 'Table View',
  ASSIGNED: 'assigned',
  ALL: 'all',
  UNASSIGNED: 'unassigned',
  DELETE_ASSIGNED_TABLE: 'Delete Table',
  ASSIGN_SENSOR_GROUP: 'Assign Sensor Group',
  DELETE_TABLE: 'Deleteing table(s)',
  ASSIGN_TABLE: 'Assign Table',
  ASSIGN_EMPLOYEE: 'Assign Employee',
  DELETE_ASSIGNED_EMPLOYEE: 'Delete Employee',
  NOTIFY: 'Notify',
  NOTIFICATIONS: 'Notifications',
  REPOST_PAYMENT: 'Repost Payment',
  CARD_TYPE: 'Card Type',
  REDACTED_CARD_NUMBER: 'Card #',
  REPOST_PAYMENT_CONFIRMATION: 'Repost Payment Confirmation',
  MOVE_SLOT: 'Move Slot',
  ERROR_ORDERS: 'Error Orders',

  //HEADER CUSTOMIZATION
    HEADER_LOCATION: 'Location',
    HEADER_CHANNEL: 'Channel',
    HEADER_ORDER_TYPE: 'Order Type',
    HEADER_REVENUE_CENTER: 'Revenue Center',
    HEADER_STATUS: 'Status',
    HEADER_EMPLOYEE: 'Employee',
    HEADER_SEARCH: 'Search',
    HEADER_ALL: 'All',
    HEADER_UNPAID: 'Unpaid',
    HEADER_SORTNAME: 'Sort by Name',
    HEADER_SORTTIME: 'Sort by Time',
    HEADER_ASC: 'ASC',
    HEADER_DEC: 'DEC',
    HEADER_CLOSED: 'Closed',
    HEADER_CUBBY_MANAGER: 'Cubby Manager',
    HEADER_FUTURE_ORDERS: 'Future Orders',
    HEADER_BULK_TEXT_TO_PAY: 'Bulk Text To Pay',
    HEADER_OUT_OF_STOCK: 'Out Of Stock',
    HEADER_FUTURE_DATE: 'Select Future Date',
    HEADER_ASSIGN_EMPLOYEE: 'Assign Employee',
    HEADER_TABLE_SENSORS: 'Table Sensors',
    HEADER_NAMED_SENSORS: 'Named Sensors',
    HEADER_ABOUT: 'About',
    HEADER_MOVESLOT: 'Move Slot',
    HEADER_ITEMS: 'Items',
    HEADER_MODIFIERS: 'Modifiers',
    HEADER_EMPLOYEEVIEW: 'Employee View',
    HEADER_TABLEVIEW: 'Table View',
    HEADER_TABLE: 'Table',
    HEADER_NAMED: 'Named',
    HEADER_SENSORGROUP: 'Sensor Group',
    HEADER_ADDSENSOR: 'Add Sensor',
    HEADER_ASSIGNSENSORGROUP: 'Assign Sensor Group',
    HEADER_ERROR_ORDERS: 'Error Orders',
    HEADER_NOTIFICATIONS: 'Notifications',

    //Checks Data
    CHECK_CHANNEL: 'CHANNEL',
    CHECK_CHECK: 'CHECK',
    CHECK_TABLETAB: 'TABLE/ TAB',
    CHECK_NAME: 'NAME',
    CHECK_PHONE: 'PHONE',
    CHECK_ELAPSED: 'ELAPSED',
    CHECK_DUE: 'DUE',
    CHECK_STATUS: 'STATUS',
    CHECK_PAID: 'PAID',
    CHECK_UNPAID: 'UNPAID',
    CHECK_STORE: 'STORE',
    CHECK_EMPLOYEE: 'EMPLOYEE',
    CHECK_OPEN: 'OPEN',
    CHECK_CLOSE: 'CLOSE',
    CHECK_CLOSED: 'Closed',
    CHECK_GUEST: 'GUEST',
    CHECK_REMAINING: 'REMAINING',
    CHECK_ORDER: 'ORDER',
    CHECK_CHECKEDIN: 'CHECKED IN',
    CHECK_CHECKINNOTE: 'CHECK IN NOTE',
    CHECK_TOTAL: 'Total',
    CHECK_CLEAR: 'Clear',
    CHECK_MOVE: 'Move',
    CHECK_MORE_DETAILS: 'More Details',
    CHECK_NOTIFY: 'Notify',
    CHECK_PROGRESS: 'Progress',
    CHECK_COMPLETE: 'Complete',
    CHECK_PICKEDUP: 'Picked Up',
    CHECK_PRINT: 'Print',
    CHECK_RECEIPT: 'Receipt',
    CHECK_PICKUP: 'Pick Up',
    CHECK_NO_CHECKS_AVAILABLE: 'No Checks Available',
    CHECK_CLEAR_SLOT_CONFIRMATION: 'Confirmation',
    CHECK_CLEAR_SLOT_MESSAGE: 'This will clear the order from Slot {{SlotNo}}. Do you want to continue?',
    CHECK_YES: 'Yes',
    CHECK_NO: 'No',

    // CHECK DETAILS
    DETAILS_ITEMS: 'Items',
    DETAILS_SUBTOTAL: 'Subtotal',
    DETAILS_DISCOUNTS: 'Discounts',
    DETAILS_CHARGES: 'Charges',
    DETAILS_TAX: 'Tax',
    DETAILS_TIP: 'Tip',
    DETAILS_PAID: 'Paid',
    DETAILS_UNPAID: 'Unpaid',
    DETAILS_DUE: 'Due',
    DETAILS_ELAPSED: 'Elapsed',
    DETAILS_REMAINING: 'Remaining',
    DETAILS_DUETIME: 'Due Time',

    // STATUS
    STATUS_PENDING: 'Pending',
    STATUS_PROGRESS: 'In Progress',
    STATUS_COMPLETE: 'Complete',
    STATUS_PICKEDUP: 'Picked Up',
    STATUS_CANCELLED: 'Cancelled',
    STATUS_ERROR: 'Error',
    STATUS_SEE_COUNTER: 'See Counter',
    STATUS_OPEN: 'Open',
    CHECK_TAB: 'TAB',

    //NOTIFY GUEST
    NOTIFY_CUSTOM_STANDARD_MESSAGES: 'Custom and Standard Messages',
    NOTIFY_CANCEL: 'CANCEL',
    NOTIFY_SUBMIT: 'SUBMIT',
    NOTIFY_OK:'OK',

    // RECEIPT SCREEN
    RECEIPT: 'Re-send Receipt',
    RECEIPT_TYPE: 'Type',
    RECEIPT_CARD: 'Card',
    RECEIPT_NAME: 'Name',
    RECEIPT_TOTAL: 'Total',
    RECEIPT_TIP: 'Tip',
    RECEIPT_REFUND: 'Refund',
    RECEIPT_PAYMENT: 'Payment',
    RECEIPT_STATUS: 'Status',
    RECEIPT_CANCEL: 'Cancel',
    RECEIPT_PRINT: 'Print',
    RECEIPT_EMAIL: 'Email',
    RECEIPT_TEXT: 'Text',
    RECEIPT_EMAIL_ADDRESS: 'Email Address',
    RECEIPT_ENTER_EMAIL: 'Enter your email',
    RECEIPT_DONE: 'Done',
    RECEIPT_PHONE_NUMBER: 'Phone Number',
    RECEIPT_ENTER_PHONE: 'Enter your phone number',
    RECEIPT_ERROR_PHONE: 'Enter valid phone number',
    RECEIPT_ERROR_EMAIL: 'Enter valid email address',
    RECEIPT_EMAIL_SPINNER_MSG: 'Generating email receipt',
    RECEIPT_SMS_SPINNER_MSG: 'Generating sms receipt',
    RECEIPT_PHONE_DIGITS_ERROR: 'Phone number requires 10 digits',

  // PRINT
  PRINT: 'Print',
  PRINT_INDIVIDUAL_ITEM_LABELS: 'Individual Item Labels',
  PRINT_ORDER_ITEM_LABELS: 'Order + Item Labels',
  PRINT_FULL_ORDER_LABEL: 'Full Order Label',
  PRINT_KITCHEN_TICKET: 'Kitchen Ticket',
  PRINT_GUEST_RECEIPT: 'Guest Receipt',
  PRINT_CANCEL: 'Cancel',
  PRINT_ERROR: 'Printer not setup for this table - Please setup a printer and try again',
  PRINT_OK: 'OK',

  ACTION_PROGRESS: 'Move To In-Progress',
  ACTION_DONE: 'Mark As Done',
  ACTION_PICKED: 'Move To Picked Up',
  ACTION_BACK_TO_PENDING: 'Back To Pending',
  ACTION_BACK_TO_INPROGRESS: 'Back To In-Progress',
  ACTION_MARK_NOT_PICKEDUP: 'Mark as Not Picked Up',
  ACTION_CANCEL_ORDER: 'Cancel Order',
  ACTION_NOTIFY_GUEST: 'Notify Guest',
  ACTION_PRINT: 'Print',
  ACTION_RECEIPT: 'Receipt',
  ACTION_SYNC_CHECK: 'Sync Check',
  ACTION_ORDER_CANCELLATION: 'Order Cancellation',
  ACTION_CANCELLATION_MESSAGE:
    'This action will cancel the order permanently. Are you sure you want to continue?',
  ACTION_YES: 'Yes',
  ACTION_NO: 'No',
  ACTION_PREAUTH: 'Pre Auth',
  ACTION_REPOST: 'Repost Payment',

  // error orders
  ERROR_CHANNEL: 'Channel',
  ERROR_CHECK_NUMBER: 'Check Number',
  ERROR_NAME: 'Name',
  ERROR_PHONE_NUMBER: 'Phone Number',
  ERROR_PICKUP_DETAILS: 'Pickup Date and Time',
  ERROR_ERROR_MESSAGE: 'Error Message',
  ERROR_NO_ERROR_ORDERS: 'No Error Orders Available',

  //employee assignment
  ASSIGN_EMPLOYEE_EMPLOYEES: 'Employees',
  ASSIGN_EMPLOYEE_SEARCH: 'Search',
  ASSIGN_EMPLOYEE_ALL: 'All',
  ASSIGN_EMPLOYEE_ASSIGNED: 'Assigned',
  ASSIGN_EMPLOYEE_UNASSIGNED: 'Unassigned',
  ASSIGN_EMPLOYEE_ASSIGN: 'Assign',
  ASSIGN_EMPLOYEE_ASSIGN_TABLE: 'Assign Table',
  ASSIGN_EMPLOYEE_YES: 'Yes',
  ASSIGN_EMPLOYEE_NO: 'No',
  ASSIGN_EMPLOYEE_DELETE_TABLE: 'Delete Table',
  ASSIGN_EMPLOYEE_TABLES: 'Tables',
  ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE: 'Assign Employee',
  ASSIGN_EMPLOYEE_DELETE_EMPLOYEE: 'Delete Employee',
  ASSIGN_EMPLOYEE_ASSIGN_TABLE_MESSAGE:
    'This will assign the table(s) to Employee {{posId}}. Do you want to continue?',
  ASSIGN_EMPLOYEE_DELETE_TABLE_MESSAGE:
    'This will delete the Table {{TableNo}} from Employee {{posId}}. Do you want to continue?',
  ASSIGN_EMPLOYEE_DELETEALL_TABLE_MESSAGE:
    'This will delete all the tables from Employee {{posId}}. Do you want to continue?',
  ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE_MESSAGE:
    'This will assign Employee {{EmployeeName}} to Table {{TableNo}}. Do you want to continue?',
  ASSIGN_EMPLOYEE_DELETE_EMPLOYEE_MESSAGE:
    'This will remove the assignment for {{EmployeeName}} from Table {{TableNo}}. Do you want to continue?',
  ASSIGN_EMPLOYEE_NO_TABLES: 'No Tables Found',
  ASSIGN_EMPLOYEE_NO_EMPLOYEES: 'No Employees Found',

  // sensor
  TABLE_SENSOR_SEARCH: 'Search',
  TABLE_SENSOR_TABLE: 'Table',
  TABLE_SENSOR_SENSOR_GROUP: 'Sensor Group',
  TABLE_SENSOR_SELECTION: 'Please make a selection',
  TABLE_SENSOR_CLEAR: 'Clear',
  TABLE_SENSOR_ADDQR: 'Add QR',
  TABLE_SENSOR_FIT_BARCODE: 'Fit the barcode completely into the box below',
  TABLE_SENSOR_SENSOR_ADDED: 'Sensor successfully added',
  TABLE_SENSOR_RESCAN: 'Re-Scan',
  TABLE_SENSOR_DONE: 'Done',
  TABLE_SENSOR_SENSOR_CODE: 'Sensor Code',
  TABLE_SENSOR_SUBMIT: 'Submit',
  TABLE_SENSOR_DELETE_SENSOR: 'Delete Sensor',
  TABLE_SENSOR_DELETE_SENSOR_MESSAGE:
    'This will delete the sensor from Table {{stationName}}. Do you want to continue?',
  TABLE_SENSOR_FAILED_MESSAGE: 'Failed to register sensor. Please try again.',
  TABLE_SENSOR_YES: 'Yes',
  TABLE_SENSOR_NO: 'No',
  NAMED_SENSOR: 'Add Sensor',
  NAMED_SENSOR_NAME_OF_SENSOR: 'Name of the Sensor',
  NAMED_ENTER_NAME: 'Enter the name',
  NAMED_SENSOR_NAME: 'Name',
  NAMED_DELETE_SENSOR:
    'This will delete the named sensor. Do you want to continue?',
  SENSOR_NO_DATA: 'No Sensors Found',

  //hamburger menu
  HAMBURGER_VIEWS: 'Views',
  HAMBURGER_LIST_VIEW: 'List View',
  HAMBURGER_TILE_VIEW: 'Tile View',
  HAMBURGER_CUBBY_MANAGER: 'Cubby Manager',
  HAMBURGER_ORDER_STATUS_MANAGER: 'Order Status Manager',
  HAMBURGER_MODES: 'Modes',
  HAMBURGER_GENERAL_MODE: 'General Mode',
  HAMBURGER_ONPREMISE_MODE: 'On Premise',
  HAMBURGER_OFFPREMISE_MODE: 'Off Premise',
  HAMBURGER_TABLE_DELIVERY: 'Table Delivery',
  HAMBURGER_PREAUTH: 'Pre Auth',
  HAMBURGER_FUTURE_ORDERS: 'Future Orders',
  HAMBURGER_BULK_TEXT_TO_PAY: 'Bulk Text To Pay',
  HAMBURGER_OUT_OF_STOCK: 'Out Of Stock',
  HAMBURGER_STORE_PRODUCTION: 'Store Production',
  HAMBURGER_TABLE_MERGE: 'Table Merge',
  HAMBURGER_ASSIGN_EMPLOYEE: 'Assign Employee',
  HAMBURGER_SENSORS: 'Sensors',
  HAMBURGER_ABOUT: 'About',

  // REPOST PAYMENT
  REPOST_PAYMENT_REPOST_PAYMENT: 'Repost Payment',
  REPOST_CARD_TYPE: 'Card Type',
  REPOST_CARD: 'Card #',
  REPOST_NAME: 'Name',
  REPOST_TOTAL: 'Total',
  REPOST_TIP: 'Tip',
  REPOST_PAYMENT_PAYMENT: 'Payment',
  REPOST_SUCCESS: 'Success',
  REPOST_CANCEL: 'Cancel',
  REPOST_SUBMIT: 'Submit',
  REPOST_YES: 'Yes',
  REPOST_NO: 'No',
  REPOST_CONFIRMATION: 'Repost Payment Confirmation',
  REPOST_MESSAGE: 'This will repost the payment to the pos. Do you want to continue?',
  REPOST_NO_DATA_AVAILABLE: 'No Data Available',

  // Loader Components
  LOADER_PROCESSING_REQUEST : 'Processing Request',
  LOADER_SPINNER_MESSAGE: 'This should only take a moment.',
  LOADER_SUCCESS_MESSAGE: 'Request completed successfully',

    // PRINT
    PRINT: 'Print',
    PRINT_INDIVIDUAL_ITEM_LABELS: 'Individual Item Labels',
    PRINT_ORDER_ITEM_LABELS: 'Order + Item Labels',
    PRINT_FULL_ORDER_LABEL: 'Full Order Label',
    PRINT_KITCHEN_TICKET: 'Kitchen Ticket',
    PRINT_GUEST_RECEIPT: 'Guest Receipt',
    PRINT_CANCEL: 'Cancel',
    PRINT_ERROR: 'Printer not setup for this table - Please setup a printer and try again',
    PRINT_OK: 'OK',

    // NOTIFICATIONS SCREEN
    NOTIFICATION_TYPE: 'Type',
    NOTIFICATION_STORE: 'Store',
    NOTIFICATION_TIME: 'Time',
    NOTIFICATION_MESSAGE: 'Message',
    NOTIFICATION_ACTIONS: 'Actions',
    NOTIFICATION_DISMISS: 'Dismiss',
    NOTIFICATION_GO_DISMISS: 'Go & Dismiss',
    NOTIFICATION_NO_NOTIFICATIONS_AVAILABLE: 'No Notifications Available',

    // BULK TEXT TO PAY
    BULK_CHECK: 'Check',
    BULK_TABLE: 'Table',
    BULK_EMPLOYEE: 'Employee',
    BULK_TOTAL: 'Total',
    BULK_PHONE_NUMBER: 'Phone Number',
    BULK_STATUS: 'Status',
    BULK_MESSAGE: 'Message',
    BULK_SUBMIT: 'Submit',
    BULK_NO_CHECKS: 'No Checks Available',
    BULK_OK: 'OK',
    BULK_PROCESSING_TEXT_TO_PAY: 'Processing text to pay for check {{CheckNo}}',

    // OUT OF STOCK
    OOS_OUT_OF_STOCK_ITEMS: 'Out Of Stock Items',
    OOS_SEARCH: 'Search',
    OOS_SELECTED_ITEMS: 'Selected Items',
    OOS_CLEAR_ALL: 'Clear All',
    OOS_MARK_IN_STOCK: 'Mark In-Stock',
    OOS_MARK_OUT_OF_STOCK: 'Mark Out Of Stock',
    OOS_UPDATE_STOCK_STATUS: 'Update Stock Status',
    OOS_IN_STOCK_ITEM_MESSAGE: 'Are you sure you want to mark this item as back in stock?',
    OOS_CANCEL: 'Cancel',
    OOS_PROCEED: 'Proceed',
    OOS_ITEM_MESSAGE: 'Are you sure you want to mark this item as Out of Stock?',
    OOS_ITEM_DATE_MESSAGE: 'Optionally, you can specify a date when the item will be back in stock.',
    OOS_SELECT_DATE: 'Select Date',
    OOS_OUT_OF_STOCK_MODIFIERS: 'Out Of Stock Modifiers',
    OOS_SELECTED_MODIFIERS: 'Selected Modifiers',
    OOS_IN_STOCK_MODIFIER_MESSAGE: 'Are you sure you want to mark this modifier as back in stock?',
    OOS_MODIFIER_MESSAGE: 'Are you sure you want to mark this modifier as Out of Stock?',
    OOS_MODIFIER_DATE_MESSAGE: 'Optionally, you can specify a date when the modifier will be back in stock.',
    OOS_NO_MODIFIERS: 'No Modifiers',
    OOS_NO_ITEMS: 'No Items',
    OOS_NO_MODIFIERS_FOUND: 'No Modifiers Found',
    OOS_NO_ITEMS_FOUND: 'No Items Found',

    // CHANNEL
    CHANNEL_POS: 'POS',
    CHANNEL_KIOSK: 'Kiosk',
    CHANNEL_CURBSIDE: 'Curbside',
    CHANNEL_ONLINE: 'Online',
    CHANNEL_WALKUP: 'Walk Up',
    CHANNEL_CALL_IN: 'Call In',
    CHANNEL_COUNTER: 'Counter',
    CHANNEL_CALL_CENTER: 'Call Center',
    CHANNEL_SPEED_ORDER: 'Speed Order',
    CHANNEL_DRIVE_THRU: 'Drive Thru',
    CHANNEL_ORDER_PAY: 'Order Pay',

    // ABOUT
    ABOUT_SYSTEM_INFO: 'System Information',
    ABOUT_STORE_NAME: 'Store Name',
    ABOUT_DEVICE_NAME: 'Device Name',
    ABOUT_DEVICE_GROUP_NAME: 'Device Group Name',
    ABOUT_WEB_VERSION: 'Web Version',
    ABOUT_ENVIRONMENT: 'Environment',
    ABOUT_SUPPORT_CONTACT: 'Support and Contact',
    ABOUT_ONEDINE: 'Support & Contact - OneDine',
    ABOUT_DOORDASH_DRIVE_DELIVERY: 'DoorDash Drive Delivery',
    ABOUT_DOORDASH_MARKETPLACE: 'DoorDash Marketplace',
    ABOUT_GRUBHUB_MARKETPLACE: 'Grubhub Marketplace',
    ABOUT_UBEREATS_MARKETPLACE: 'UberEats Marketplace',

    // COUNTERS
    COUNTER_ALL_CHECKS: 'All Checks',
    COUNTER_OPEN: 'Open',
    COUNTER_PAID: 'Paid',
    COUNTER_PARTIAL_PAID: 'Partial Paid',
    COUNTER_UNPAID: 'Unpaid',
    COUNTER_REPOST: 'Repost',
    COUNTER_PENDING: 'Pending',
    COUNTER_IN_PROGRESS: 'In Progress',
    COUNTER_DONE: 'Done',
    COUNTER_PICKED_UP: 'Picked Up',
    COUNTER_CHECKED_IN: 'Checked In',
    COUNTER_UNASSIGNED: 'Unassigned',

  // Toast
  TOAST_ORDER_STATUS: 'Order Status Updated Successfully',
  TOAST_NOTIFY_GUEST: 'Notification Sent Successfully',
  TOAST_SUCCESS: 'Request Successful',
  TOAST_EMAIL_SUCCESS: 'Email Sent Successfully',
  TOAST_SMS_SUCCESS: 'SMS Sent Successfully',
  TOAST_MARK_OUTOFSTOCK: 'Successfully Marked As Out Of Stock',
  TOAST_MARK_INSTOCK: 'Successfully Marked As In Stock',
  TOAST_ASSIGN_TABLE: 'Successfully Assigned Table(s)',
  TOAST_ASSIGN_EMPLOYEE: 'Successfully Assigned Employee',
  TOAST_DELETE_TABLE: 'Successfully Deleted Table(s)',
  TOAST_DELETE_EMPLOYEE: 'Successfully Deleted Employee',
  TOAST_ADD_SENSOR: 'Successfully Added Sensor',
  TOAST_UPDATE_SENSOR: 'Successfully Updated Sensor',
  TOAST_DELETE_SENSOR: 'Successfully Deleted Sensor',
  TOAST_ASSIGN_SLOT: 'Slot {{SlotNo}} Is Assigned',
  TOAST_CLEAR_SLOT: 'Successfully Cleared Slot {{SlotNo}}',
  TOAST_MOVE_SLOT: 'Successfully Moved To Slot {{SlotNo}}',
};
